import styled, { css } from 'styled-components';

import { iconSize, styledInteraction, styledLayout, styledMedia, styledReset } from '@pkg/primitives';

import { tokens } from '../../../../tokens';

interface NftActionProps {
    $active?: boolean;
}

const fadeMotion = css`
    transition-property: opacity;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};
`;

export const NftAction = styled.button.attrs({ type: 'button' })<NftActionProps>`
    ${styledReset.button};
    ${styledInteraction.focusRing({
        width: tokens.item.action.focusRing.width,
        offset: -tokens.item.action.focusRing.offset,
        radius: tokens.item.action.focusRing.radius,
    })};

    --yat_nft-action-opacity: 1;
    --yat_nft-action-radius: ${tokens.item.action.radius}px;
    --yat_nft-action-active-ring-opacity: ${({ $active }) => ($active ? 1 : 0)};

    && {
        z-index: ${tokens.item.zIndex.action};
        position: relative;
        width: 100%;
        height: 100%;
        border-radius: var(--yat_nft-action-radius);

        &:hover {
            --yat_nft-action-active-ring-opacity: 0.8;
        }

        &:active {
            --yat_nft-action-opacity: 0.8;
        }

        &:disabled {
            --yat_nft-action-opacity: 0.6;
            cursor: not-allowed;
        }

        &::after {
            ${styledLayout.positionCover({ offset: tokens.item.action.activeRing.offset })};
            ${fadeMotion};
            content: '';
            display: block;
            border-radius: var(--yat_nft-action-radius);
            box-shadow: 0 0 0 ${tokens.item.action.activeRing.width}px ${({ theme }) => theme.colors.purple};
            opacity: var(--yat_nft-action-active-ring-opacity);
        }
    }
`;

export const Interior = styled.div`
    z-index: ${tokens.item.zIndex.interior};
    position: relative;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.black};
    border-radius: var(--yat_nft-action-radius);
    overflow: hidden;
`;

export const AssetWrapper = styled.div`
    ${fadeMotion};
    width: 100%;
    height: 100%;
    opacity: var(--yat_nft-action-opacity);
`;

export const DisabledIndicator = styled.div`
    ${styledLayout.positionCover()};
    ${styledMedia.iconWrapper};
    width: ${iconSize.default}px;
    height: ${iconSize.default}px;
`;
